<div>
    <app-base-report
      *ngIf="smsMarketingRequestsData"
      [filterFields]="filterField"
      [hasDateRangeFilter]="true"
      [hasCheckboxes]="true"
      [customSelectionRows]="selectableRows"
      [reportName]="'Sms Marketing Requests'"
      [defaultColumns]="tableColumns"
      [columnsDisplayNames]="displayTableColumns"
      [data]="smsMarketingRequestsData"
      [rowsLength]="totalNumberOfRecords"
      (filterTrigger)="filter($event)"
      (paginationChange)="paginate($event)"
      (searchChange)="searchChange($event)"
      [tableLoading]="loading"
      [selectionModel]="selectionModel"
      [selectionActions]="selectionActions"
      (selectionActionTrigger)="selectionActionsCB($event)"
      [hasSort]="true"
      (sortTrigger)="sortChange($event)"
      [serviceInstance]="smsMarketingRequests"
    ></app-base-report>
  </div>
  